import React, { useState, useEffect } from 'react';
import '../styles/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import logo from '../components/images/logo.png';
import { ContenidoDinamico } from '../routes/AppRoutes';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const PaginaAlumno = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Obtenemos la ubicación actual de la URL
  const [sidebarVisible, setSidebarVisible] = useState(false); // Estado para controlar la visibilidad del sidebar
  const [submenuVisible, setSubmenuVisible] = useState(false); // Estado para controlar la visibilidad del submenú de sesión

  // Obtener el nombre completo del alumno desde localStorage
  const nombreMostrar = localStorage.getItem('displayName') || 'Usuario'; // Mostrar el nombre completo del alumno o 'Usuario'

  // Lógica para verificar que el usuario es un alumno (rol 4)
  useEffect(() => {
    const userRole = Number(localStorage.getItem('role'));
    const token = localStorage.getItem('token');

    // Verifica si el rol es el adecuado y si hay un token de sesión
    if (userRole !== 4 || !token) {
      // Si no es un alumno (rol 4) o no tiene sesión activa, redirige
      navigate('/login', { replace: true });
    }

    // Validar las rutas específicas del alumno
    const allowedRoutes = [
      '/alumno',
      '/alumno/inicio',
      '/alumno/consultar-informacion-alumno',
      '/alumno/consultar-alumnohorario',
      '/alumno/consultar-calificaciones-alumno'
    ];

    if (!allowedRoutes.includes(location.pathname)) {
      // Si la ruta no es una de las permitidas para alumno, redirigir al inicio
      navigate('/alumno/inicio', { replace: true });
    }
  }, [navigate, location]);


  

  // Manejo del cierre de sesión
  const handleLogout = () => {
    // Eliminar las credenciales y otros datos del usuario
    localStorage.clear(); // Limpiar localStorage
    // Redirigir al inicio de sesión
    navigate('/login', { replace: true }); // Redirigir al login
  };

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible); // Alterna la visibilidad del sidebar
  };

  // Función para mostrar/ocultar el submenú de "Cerrar sesión"
  const toggleSubmenu = () => {
    setSubmenuVisible(!submenuVisible); // Alterna la visibilidad del submenú
  };

  return (
    <div className="pagina-alumno d-flex" style={{ height: '100vh', overflow: 'auto' }}>
      {/* Botón hamburguesa para móviles */}
      <button className="hamburger-btn d-md-none" onClick={toggleSidebar}>
        <i className="fa fa-bars"></i>
      </button>

      {/* Panel lateral izquierdo */}
      <div className={`sidebar ${sidebarVisible ? 'active' : ''}`}>
        <div className="menu">
          <span className="titulo-left">Plataforma Digital Escolar</span>

          {/* Botón de inicio */}
          <div className="submenu">
            <Link
              to="/alumno/inicio"
              className="submenu-btn d-flex align-items-center gap-2"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <i className="fa fa-house"></i>
              <span>Inicio</span>
            </Link>
          </div>

          {/* Opciones del alumno */}
          <div className="submenu">
            <button className="submenu-btn">
              <i className="fa fa-user"></i>
              <Link to="/alumno/consultar-informacion-alumno" style={{ all: 'unset', cursor: 'pointer' }}>
                Consultar Información
              </Link>
            </button>

            <button className="submenu-btn">
              <i className="fa fa-clock"></i>
              <Link to="/alumno/consultar-alumnohorario" style={{ all: 'unset', cursor: 'pointer' }}>
                Consultar Horario
              </Link>
            </button>

            <button className="submenu-btn">
              <i className="fa fa-file-signature"></i>
              <Link to="/alumno/consultar-calificaciones-alumno" style={{ all: 'unset', cursor: 'pointer' }}>
                Consultar Calificaciones
              </Link>
            </button>
          </div>
        </div>
      </div>

      {/* Panel principal: topbar + contenido dinámico */}
      <div className="d-flex flex-column flex-grow-1">
        <div className="topbar d-flex justify-content-between align-items-center px-4 py-2">
          <span className="titulo-top d-flex align-items-center">
            <img src={logo} alt="Logo del Instituto" width="30" height="30" className="me-2" />
            Instituto Silviano Carrillo
          </span>

          {/* Submenú sesión */}
          <div className="submenu">
            <button className="submenu-btn btn-sesion" onClick={toggleSubmenu}>
              <i className="fa fa-user"></i>
              <span>{nombreMostrar}</span> {/* Muestra el nombre completo del alumno */}
              <i className="fa fa-chevron-down arrow"></i>
            </button>

            {/* Submenú con "Cerrar sesión" */}
            {submenuVisible && (
              <div
                style={{
                  display: "block",
                  position: "absolute",
                  top: "100%",       // debajo del botón
                  right: "0",        // alineado a la derecha
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 12px rgba(7, 152, 249, 0.15)",
                  borderRadius: "8px",
                  minWidth: "180px",
                  zIndex: 1000,
                }}
              >
                <button
                  onClick={handleLogout}
                  style={{
                    padding: "10px 16px",
                    color: "#1976d2",
                    border: "none",
                    background: "none",
                    fontSize: "14px",
                    width: "100%",
                    textAlign: "left",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onMouseOver={e => (e.currentTarget.style.backgroundColor = "#67c6ff")}
                  onMouseOut={e => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <i className="fa fa-right-from-bracket"></i>
                  <span>Cerrar sesión</span>
                </button>
              </div>
            )}

          </div>


        </div>

        {/* Contenido dinámico */}
        <main className="contenido-principal flex-grow-1 p-4" id="contenido-dinamico">
          <ContenidoDinamico />
        </main>
      </div>
    </div>
  );
};

export default PaginaAlumno;
